import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const PcbInstructions = () => {
  const [showModal, setShowModal] = useState(false);

  const instructions = [
    {
      img: Spree.image_assets.pcb_instruction_one,
      title: 'Fill out the form',
      description:
        'Enter the circuit board specs and click on the quote button',
    },
    {
      img: Spree.image_assets.pcb_instruction_two,
      title: 'Select a price from price matrix',
      description: 'Select the price based on quantity and leadtime',
    },
    {
      img: Spree.image_assets.pcb_instruction_three,
      title: 'Upload your gerber files',
      description: 'Gerber files must be compressed in Zip format',
    },
  ];

  const onShowModal = () => {
    setShowModal(true);
  };

  const onHideModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      <img src={Spree.image_assets.info_icon_02} className="mr-1" alt="Pcb Instructions" />
      <Button variant="link" className="p-0 pcb-instructions-button font-weight-bold" onClick={onShowModal}>
        How do I get a quote?
      </Button>

      <Modal show={showModal} onHide={onHideModal} size="lg">
        <Modal.Body>
          <div className="container-fluid instructions">
            <div className="row">
              <div className="col-12">
                <h3 className="font-weight-bold text-center">How to get a quote online?</h3>
              </div>
            </div>
            <div className="row">
              {instructions.map((instruction, index) => (
                <div className="col-md-4 instruction" key={index}>
                  <img
                    src={instruction.img}
                    className="d-block mx-auto"
                    alt={instruction.title}
                  />
                  <div className="instruction-title">
                    <span className="instruction-icon">{index + 1}</span>
                    <span>{instruction.title}</span>
                  </div>
                  <p className="instruction-description">
                    {instruction.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default PcbInstructions;
